module.exports = __webpack_public_path__ + "static/media/Screenshot .7fbee510.png";